import { formatCurrency } from '../format-currency/index.js'
import { useCore } from '@/composables/core/index.js'

export const formatSubscriptionCurrency = (...args) => {
  const { store } = useCore()
  const subscriptionCurrencyCode = store.getters['subscription/currency']

  if (subscriptionCurrencyCode === null) {
    throw Error('Cannot get values from store. Did you fetch API data?')
  }

  if (subscriptionCurrencyCode) {
    args[1] = {
      ...args[1],
      currency: subscriptionCurrencyCode,
    }
  }
  return formatCurrency(...args)
}
